import React, { Component } from 'react'
import styled from 'styled-components'
import { pxToRem, color, ie } from '../../utils'
import closeIcon from '../../assets/icons/close.svg'
import { SimpleLoader } from '../loaders'
import ModalContent from './ModalContent'

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: ${ie.isIe11() ? 'block' : 'flex'};
  overflow-y: auto;
  align-items: center;
  justify-content: center;
  visibility: hidden;
  z-index: 9999;
  transition: 0.05s 0.15s;
  align-items: center;
  justify-content: center;
  background: transparent;
  padding: ${pxToRem('20px')} ${pxToRem('10px')};

  ${({ open }) => {
    return open
      ? `
      visibility: visible;
      z-index: 9999;
      transition: .2s;
    `
      : ''
  }};
`

const ModalError = styled.div`
  color: #444;
  width: 100%;
  height: 100%;
  text-align: center;
  font-weight: bold;
  padding: 2em 0.3em;
`

const Box = styled.div`
  width: calc(100% - ${pxToRem('10px')});
  border-radius: 7px;
  background-color: #fff;
  margin: auto;
  z-index: 1;
  transition: 0.2s;
  transform: translateY(-25%);
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);
  overflow: ${ie.isIe11() ? 'visible' : 'hidden'};
  opacity: 0;
  min-height: ${pxToRem(100)};
  ${({ open }) => {
    return open
      ? `
      transition: transform .2s .2s, box-shadow .2s .2s, opacity .2s .2s, max-width .2s, max-height .2s;
      transform: translateY(0);
      opacity: 1;
      box-shadow: 0 5px 30px 0 rgba(0,0,0,.5);
    `
      : ''
  }} 
  ${({ size }) => {
    if (size === 'small') {
      return `max-width: ${pxToRem('520px')};`
    }
    if (size === 'large') {
      return `max-width: ${pxToRem('1162px')};`
    }
  }};
`

const CloseButton = styled.button`
  width: ${pxToRem('20px')};
  margin: 0;

  background: none;
  border: none;
  outline: none;
  padding: 0;
  padding-top: 2px;
  box-sizing: content-box;
  cursor: pointer;
  img {
    max-width: 100%;
  }
`

const Header = styled.header`
  font-family: 'Open Sans', sans-serif;
  font-size: ${pxToRem(21)};
  text-align: left;
  color: ${color.secondary};
  margin: 0;
  padding: ${pxToRem(16)};
  border-bottom: 1px solid #d8d8d8;
  display: flex;

  @media only screen and (max-width: 700px) {
    font-size: ${pxToRem('20px')};
  }
`

const Title = styled.div`
  flex: 1;
  ${({ error }) =>
    error
      ? `
    color: ${color.danger};
  `
      : ''};
`

const BackDrop = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;
  transition: 0.2s 0.2s;
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.7);
  cursor: pointer;

  ${({ open }) => {
    return open
      ? `
      opacity: 1;
      transition: .2s;
    `
      : ''
  }};
`

const SafeContent = styled.div`
  padding: ${pxToRem('20px')};
`

class Modal extends Component {
  renderContent = () => {
    const {
      children,
      title,
      open,
      closeMethod,
      safeContent,
      error = false,
      loading = true,
      errorMessage = 'Falha ao carregar as informações.',
      errorText = 'Por favor, tente novamente mais tarde.',
      onEntered
    } = this.props

    if (!open) return <SimpleLoader />

    if (error) {
      return (
        <div>
          <Header>
            <Title error={true}>{errorMessage}</Title>
            <CloseButton onClick={closeMethod} aria-label={'Fechar'}>
              <img aria-hidden={true} alt="close icon" src={closeIcon} />
            </CloseButton>
          </Header>
          <SafeContent>
            <ModalError>{errorText}</ModalError>
          </SafeContent>
        </div>
      )
    }

    if (loading) {
      return <SimpleLoader />
    }

    return (
      <ModalContent
        title={title}
        closeMethod={closeMethod}
        safeContent={safeContent}
        children={children}
        onEntered={onEntered}
      />
    )
  }
  render() {
    const {
      children,
      title,
      open,
      closeMethod,
      safeContent,
      error = false,
      size = 'small',
      loading = true,
      onEntered,
      ...rest
    } = this.props

    return (
      <Wrapper
        open={open}
        role={'alertdialog'}
        aria-hidden={!open}
        aria-labelledby={`modal-title-${title}`}
      >
        <Box
          {...rest}
          open={open}
          size={loading ? 'small' : size}
          role="document"
          id={`modal-${title}`}
          tabindex="0"
          error={error}
        >
          {this.renderContent()}
        </Box>
        <BackDrop className={'fix-modal-ie'} onClick={closeMethod} open={open} />
      </Wrapper>
    )
  }
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js